import { Box, BoxProps, Typography, Skeleton } from '@mui/material';
import React from 'react';
import { AppointmentAssessmentChip } from './appointment-assessment-chip.component';
import { NoteInternalAssessment } from '@uplift/api';
import { useAppointmentAssessmentsBySubmissionIds } from '@uplift/queries';

export type AppointmentAssessmentsProps = {
  assessments: NoteInternalAssessment[];
} & BoxProps;

export const AppointmentAssessments: React.VFC<AppointmentAssessmentsProps> = ({
  assessments,
  ...boxProps
}) => {
  const { data, isLoading } = useAppointmentAssessmentsBySubmissionIds(assessments.map(a => a.submissionId));

  if (isLoading) {
    return (
      <Box {...boxProps}>
        <Skeleton variant="rectangular" height={32} width={220} />
      </Box>
    );
  }

  if (!data?.length) return null;

  const reviewedAssessments = data.filter(aa => !!assessments.find(a => a.submissionId === aa.submissionId && a.isReviewed));

  return (
    <>
      <Box display="flex" flexWrap="wrap" gap="1rem" {...boxProps}>
        {data.map((assessment) => <AppointmentAssessmentChip appointmentAssessment={assessment} key={assessment.submissionId} />)}
      </Box>
      {reviewedAssessments.length > 0 && (
        <Box display="flex" flexWrap="wrap" gap="1rem" {...boxProps}>
          <Typography>
            Provider reviewed client’s {reviewedAssessments.map(a => a.formTitle).join(', ')}
          </Typography>
        </Box>
      )}
    </>
  );
};
